/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveReportRequest200Response
 */
export interface SaveReportRequest200Response {
    /**
     * 
     * @type {string}
     * @memberof SaveReportRequest200Response
     */
    id: string;
}

/**
 * Check if a given object implements the SaveReportRequest200Response interface.
 */
export function instanceOfSaveReportRequest200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function SaveReportRequest200ResponseFromJSON(json: any): SaveReportRequest200Response {
    return SaveReportRequest200ResponseFromJSONTyped(json, false);
}

export function SaveReportRequest200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveReportRequest200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function SaveReportRequest200ResponseToJSON(value?: SaveReportRequest200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

